import React, { Dispatch, SetStateAction } from "react";
import { HiOutlineMail } from "react-icons/hi";
import { MdClose } from "react-icons/md";

import ContainedButton from "components/layout/form/containedButton";
import { UserInfo } from "features/meus-dados";

import {
  Container,
  ContainerButtons,
  ContainerText,
  IconContainer,
  Text,
} from "./styles";
import { ModalHeader, ModalStyle, Title } from "../styles";

type EmailConfirmProps = {
  openModal: boolean;
  modalFunction: Dispatch<SetStateAction<boolean>>;
  email: string;
  userInfo: UserInfo;
};

const EmailConfirm = ({
  openModal,
  modalFunction,
  email,
  userInfo,
}: EmailConfirmProps): JSX.Element => {
  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Atenção</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Title>
          {userInfo && userInfo.email
            ? "Aguardando confirmação"
            : "Cadastre seu e-mail"}
        </Title>
        <ContainerText>
          {!userInfo ||
            (!userInfo.email && (
              <IconContainer>
                <HiOutlineMail size={20} color="#F0B01B" />
              </IconContainer>
            ))}
          <Text>
            Confirme seu email com o link enviado para {email}. Sua alteração
            será salva após a confirmação!
          </Text>
        </ContainerText>
        <ContainerButtons>
          <ContainedButton onClick={() => modalFunction(false)}>
            OK
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default EmailConfirm;
